<template>
<baseFormField :title="title" :error="error">
              <textarea class="form__input form__input--area" v-model="dataValue" :placeholder="placeholder"></textarea>
              </baseFormField>
</template>
<script>
//import baseFormField from './baseFormField'
import FormFieldMixin from '@/mixins/FormFieldMixins'
export default {
    mixins:[FormFieldMixin],
 //props:['title','error','placeholder','value'],
 //components:{baseFormField},
// computed:{
  //      dataValue:{
       //     get(){
     //          return this.value
      //      }

        //,set(value){
        //    this.$emit('input',value)
        //}}

 }


//}
    
</script>